import React from 'react';
import { Trophy, Medal, Award } from 'lucide-react';
import useHomePageContent from '../../hooks/useHomePageContent';

const HeadCoach = () => {
  const { content } = useHomePageContent();

  const achievements = [
    {
      icon: Trophy,
      title: content.coach_achievement_1_title,
      description: content.coach_achievement_1_desc,
    },
    {
      icon: Medal,
      title: content.coach_achievement_2_title,
      description: content.coach_achievement_2_desc,
    },
    {
      icon: Award,
      title: content.coach_achievement_3_title,
      description: content.coach_achievement_3_desc,
    },
  ];

  const qualifications = [
    content.coach_qualification_1,
    content.coach_qualification_2,
    content.coach_qualification_3,
    content.coach_qualification_4,
  ].filter(Boolean);

  return (
    <section id="manager" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] transform rotate-6 rounded-2xl"></div>
            <img
              src="/images/Vitaliy_leikin.jpg"
              alt="Виталий Лейкин"
              className="relative rounded-2xl shadow-2xl transform -rotate-6 hover:rotate-0 transition-transform duration-500 w-full object-cover"
            />
          </div>

          <div className="space-y-8">
            <div>
              <h2 className="text-4xl font-bold mb-4 text-gray-900">{content.coach_name}</h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4]"></div>
            </div>

            <p className="text-xl text-gray-600">{content.coach_description}</p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {achievements.map((achievement, index) => (
                <div key={index} className="group bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] p-0.5 mb-4">
                    <div className="w-full h-full bg-white rounded-lg flex items-center justify-center">
                      <achievement.icon className="w-6 h-6 text-[#662d91] group-hover:text-[#4897d2] transition-colors" />
                    </div>
                  </div>
                  <p className="font-semibold text-gray-900">{achievement.title}</p>
                  <p className="text-sm text-gray-600 mt-1">{achievement.description}</p>
                </div>
              ))}
            </div>

            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-gray-900">{content.coach_qualifications_title}</h3>
              <ul className="space-y-2 text-gray-600">
                {qualifications.map((item, idx) => (
                  <li key={idx} className="flex items-center">
                    <div className="w-2 h-2 bg-[#662d91] rounded-full mr-3"></div>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeadCoach;
